import { render, staticRenderFns } from "./RoundTableAddEdit.vue?vue&type=template&id=c4b11ea4"
import script from "./RoundTableAddEdit.vue?vue&type=script&lang=js"
export * from "./RoundTableAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports